<div class="bgc-polar-gradient d-flex images-row justify-content-center m-0 w-100 {{containerCssClass}}">
    <div class="bs-row container d-flex justify-content-center">
      <div class="col-2 col-sm-2 h130px h-sm-200px mx-1 mx-sm-0 mx-sm-2"></div>
      <div class="col-2 col-sm-2 h130px h-sm-200px mx-1 mx-sm-0 mx-sm-2"></div>
      <div class="col-3 col-sm-2 h130px h-sm-200px mx-1 mx-sm-0 mx-sm-2"></div>
      <div class="col-2 col-sm-2 h130px h-sm-200px mx-1 mx-sm-0 mx-sm-2 d-none d-sm-block"></div>
      <div class="col-2 col-sm-2 h130px h-sm-200px mx-1 mx-sm-0 mx-sm-2"></div>
    </div>
</div>
